import "./FounderAttorney.module.css";
import Header from "@/reusable_sections/Header";
import Biography from "./sections/Biography";
import Footer from "@/reusable_sections/Footer";
export default function FounderAttorneyPage() {
  return <div>
      <Header />
      <Biography />
      <Footer />
    </div>;
}